import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, TextField } from '@mui/material';
import useStyles from './styles';
import getIsError from '../../../../utils/helper_functions/getIsError';
import getErrorMessage from '../../../../utils/helper_functions/getErrorMessage';
import getHintMessage from '../../../../utils/helper_functions/getHintMessage';
import equalizeFunction from '../../../../utils/helper_functions/equalizeFunction';
import { inputDataCustom } from '../../../../utils/custom_prop_types/customPropTypes';

export default function StableSection({
  validation,
  inputData,
  setInputDataToSend,
  fetchProductsBySection,
}) {
  const classes = useStyles();

  const handleInputChange = ({ currentTarget }, type) => {
    setInputDataToSend(type, currentTarget.value);
  };

  const handleCornersChange = (currentTarget, type) => {
    handleInputChange(currentTarget, type);
    if (inputData.postGroupNumber) {
      fetchProductsBySection({
        section: 'corner_post',
        panelGroup: inputData.panelGroupNumber,
        postGroup: inputData.postGroupNumber,
        color: inputData.color,
      });
    }
  };

  return (
    <>
      <div className={classes.textInput}>
        <TextField
          fullWidth
          value={inputData.distance || ''}
          error={getIsError('distance', validation.form)}
          helperText={getErrorMessage('distance', validation.form)
          || getHintMessage('This value should be greater than 0',
            equalizeFunction('greater', inputData.distance))}
          color="primary"
          id="distance"
          label="Distance"
          onChange={(event) => { handleInputChange(event, 'distance'); }}
          variant="outlined"
          InputProps={{
            endAdornment: <InputAdornment className={classes.adornment} position="end">meters</InputAdornment>,
          }}
        />
      </div>
      <div className={classes.textInput}>
        <TextField
          fullWidth
          value={inputData.corners || ''}
          error={getIsError('cornersQuantity', validation.form)}
          helperText={getErrorMessage('cornersQuantity', validation.form)
          || getHintMessage('This value should be greater than or equal to 0',
            equalizeFunction('greaterorequal', inputData.corners))}
          color="primary"
          type="number"
          id="corners"
          label="Corners"
          onChange={(event) => { handleCornersChange(event, 'corners'); }}
          variant="outlined"
        />
      </div>
      <div className={classes.textInput}>
        <TextField
          fullWidth
          value={inputData.openings || ''}
          error={getIsError('openingsQuantity', validation.form)}
          helperText={getErrorMessage('openingsQuantity', validation.form)
          || getHintMessage('This value should be greater than or equal to 0',
            equalizeFunction('greaterorequal', inputData.openings))}
          color="primary"
          type="number"
          id="openings"
          label="Openings"
          onChange={(event) => { handleInputChange(event, 'openings'); }}
          variant="outlined"
        />
      </div>
    </>
  );
}

StableSection.propTypes = {
  validation: PropTypes.objectOf(PropTypes.any).isRequired,
  inputData: inputDataCustom.isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
  fetchProductsBySection: PropTypes.func.isRequired,
};
